import React, { useState } from "react";
import { TableLoader } from "../../../Common/ShimmerLoader";
import { useLocation, useNavigate } from "react-router-dom";
import CustomDataTable from "../../../Common/ReportTable/ReportTable";
import * as XLSX from "xlsx";

const ScvCircleInnerCollectionPointTrans = () => {
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();
  const data = location.state;
  // console.log("Data type:-----------------", typeof data);
  // console.log("Data content:---------------------", data);
  const navigate = useNavigate();

  const scvReportColumns = [
    {
      name: "S.No",
      selector: (row) => row["sno"],
      sortable: true,
      format: (row, rowIndex) => rowIndex + 1,
    },
    {
      name: "Zone",
      selector: (row) => (
        <span
        // style={{ color: "blue", cursor: "pointer" }}
        //   onClick={() => handleZoneClick(row["zoneId"])}
        >
          {row["zoneName"] || "N/A"}
        </span>
      ),
      sortable: true,
    },
    {
      name: "Circle",
      selector: (row) => (
        <span
        // style={{ color: "blue", cursor: "pointer" }}
        //   onClick={() => handleZoneClick(row["zoneId"])}
        >
          {row["circleName"] || "N/A"}
        </span>
      ),
      sortable: true,
    },
    {
      name: "Ward",
      selector: (row) => (
        <span
        // style={{ color: "blue", cursor: "pointer" }}
        //   onClick={() => handleZoneClick(row["zoneId"])}
        >
          {row["wardName"] || "N/A"}
        </span>
      ),
      sortable: true,
    },
    {
      name: "Collection Point",
      selector: (row) => (
        <span
        // style={{ color: "blue", cursor: "pointer" }}
        //   onClick={() => handleZoneClick(row["zoneId"])}
        >
          {row["collectionPointName"] || "N/A"}
        </span>
      ),
      sortable: true,
    },
    {
      name: "Vehicle Type",
      selector: (row) => (
        <span
        >
          {row["vehicleTypeName"] || "N/A"}
        </span>
      ),
      sortable: true,
    },
    {
      name: "Vehicle Capacity",
      selector: (row) => (
        <span
        >
          {row["vehicleCapacityName"] || "N/A"}
        </span>
      ),
      sortable: true,
    },
    {
      name: "Driver",
      selector: (row) => (
        <span > {row["driverName"] || "N/A"}</span>
      ),
      sortable: true,
    },
    {
      name: "Driver Number",
      selector: (row) => (
        <span > {row["mobileNumber"] || "N/A"}</span>
      ),
      sortable: true,
    },
  ];

  const downloadAsExcel = () => {
    if (!data) return; // Check if data is initialized
    // Add serial number to each item in the collection details
    const dataWithSerialNumber = data.map((item, index) => ({
      ...item,
      's.no': index + 1,
    }));
  
    // Filter out only the data corresponding to the headers displayed in the table component
    const filteredData = dataWithSerialNumber.map(item => ({
      's.no': item['s.no'],
      zone: item.zoneName?? "N/A",
      circle: item.circleName?? "N/A",
      ward: item.wardName?? "N/A",
      CollectionPoint: item.collectionPointName?? "N/A",
      VehicleTypeName: item.vehicleTypeName?? "N/A",
      Driver: item.driverName?? "N/A",
      DriverNumber:item.mobileNumber?? "N/A" 
    }));

    const ws = XLSX.utils.json_to_sheet(filteredData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "SCVsInnerGVPReport");
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const excelBlob = new Blob([excelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8" });
    const downloadLink = document.createElement("a");
    downloadLink.href = URL.createObjectURL(excelBlob);
    downloadLink.download = "SCVsCircleInnerGVPReport.xlsx";
    downloadLink.click();
  };


  return (
    <>
      <div style={{ width: "100%" }}>
        <div className="content">
          <div className="page-content">
            <div className="top-header page-title">
              <span>{" "}
                    GVPs Inner Clearance Report</span>
            </div>
            <div className="page-header"></div>
            <div className="d-flex justify-content-end mb-3 mt-3">
              <button className="btn btn-secondary me-2"
                onClick={() => navigate(-1)}
              >
                Back
              </button>
              <button
                className="btn btn-excel"
                onClick={downloadAsExcel}
              >
             <i class="fa-solid fa-file-excel me-1 icon-container"></i> Excel
              </button>
            </div>
            <div className="card mt-3">
              <div className="card-body">

                <CustomDataTable data={data} columns={scvReportColumns} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ScvCircleInnerCollectionPointTrans;
